import React from 'react';
import { IconProps } from '../types';

export const VideoShootIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8892_8443)">
            <path d="M15.9999 24.6667H22.6666V26.6667H15.9999V24.6667Z" fill={color} />
            <path d="M19.9999 20.6667H15.9999V22.6667H19.9999V20.6667Z" fill={color} />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.66658 19.5923L12.6512 23.6667L5.66658 27.7411V19.5923ZM7.66658 24.259L8.68195 23.6667L7.66658 23.0744V24.259Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.8956 7.45959L30.0742 0.174194L0.333252 5.83915V31.6667H31.6666V11H12.4231L31.8956 7.45959ZM2.33325 10.8018V7.49415L6.61058 6.67942L7.46514 9.8687L2.33325 10.8018ZM9.4395 9.50972L14.7988 8.5353L13.9281 5.28562L8.58058 6.30418L9.4395 9.50972ZM15.8981 4.91038L16.7732 8.17633L22.1318 7.20203L21.2449 3.89194L15.8981 4.91038ZM24.1062 6.84306L23.2149 3.5167L28.5923 2.49244L29.4376 5.87371L24.1062 6.84306ZM2.33325 15.3334V13H7.29836L6.45482 15.3334H2.33325ZM2.33325 17.3334V29.6667H29.6666V17.3334H2.33325ZM29.6666 15.3334V13H24.0917L23.2482 15.3334H29.6666ZM21.1215 15.3334L21.965 13H16.7584L15.9148 15.3334H21.1215ZM13.7882 15.3334L14.6317 13H9.42504L8.5815 15.3334H13.7882Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8892_8443">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
